// Debe coincidir con AreaOperador.CHOICES en apps/generics/enums.py (backend)
export const AREAS_OPERADOR = [
  { value: "ALMACEN", label: "Almacén" },
  { value: "LASER", label: "Láser" },
  { value: "INYECCION", label: "Inyección" },
  { value: "MOLINO", label: "Molino" },
];

export function etiquetaArea(codigo) {
  return AREAS_OPERADOR.find((a) => a.value === codigo)?.label ?? "";
}
